import { Record } from 'immutable';

import { PROCESSING_STATES } from '../../modules/constants';

import {
  CONTACT_FORM_UPDATE,
  CONTACT_FORM_STATUS,
  CONTACT_FORM_ERROR,
  CONTACT_FORM_TICKET,
} from './actions';

const InitialState = new Record({
  formTitle: '',
  formBody: '',
  formFields: '',
  termsLabel: '',
  termsDestinationUrl: '',
  formButtonText: '',
  zendeskQueue: '',
  formStatus: PROCESSING_STATES.initial,
  ticketID: '',
  formError: '',
});

export const initialState = new InitialState();

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CONTACT_FORM_UPDATE: {
      const {
        formTitle,
        formBody,
        formFields,
        termsLabel,
        termsDestinationUrl,
        formButtonText,
        zendeskQueue,
      } = payload;

      return state
        .set('formTitle', formTitle)
        .set('formBody', formBody)
        .set('formFields', formFields)
        .set('termsLabel', termsLabel)
        .set('termsDestinationUrl', termsDestinationUrl)
        .set('formButtonText', formButtonText)
        .set('zendeskQueue', zendeskQueue);
    }
    case CONTACT_FORM_STATUS: {
      const { status } = payload;

      return state.set('formStatus', status);
    }
    case CONTACT_FORM_ERROR: {
      return state.set('formError', payload);
    }
    case CONTACT_FORM_TICKET: {
      return state.set('ticketID', payload);
    }
    default: {
      return state;
    }
  }
};
